import { buildBreadcrumbNavigationConfig } from "../../../shared/helpers/buildBreadcrumbNavigationConfig";
import { ListTasks } from "./pages/list-tasks.component";
import { ViewTask } from "./pages/view-task";
import { EditTask } from "./pages/edit-task";

const listPath = "/tasks";
const viewItemPath = "/tasks/:taskId";
const editItemPath = "/tasks/:taskId/edit";

const listNav = buildBreadcrumbNavigationConfig("Tasks", listPath);
const viewItemNav = buildBreadcrumbNavigationConfig("View", viewItemPath);
const editItemNav = buildBreadcrumbNavigationConfig("Edit", editItemPath);

export const tasksRoutes = [
  {
    path: listPath,
    Component: ListTasks,
    exact: true,
    isPrivate: true,
    navigation: [listNav],
  },
  {
    path: viewItemPath,
    Component: ViewTask,
    exact: true,
    isPrivate: true,
    navigation: [listNav, viewItemNav],
  },
  {
    path: editItemPath,
    Component: EditTask,
    exact: true,
    isPrivate: true,
    navigation: [listNav, editItemNav],
  },
];
